import React from 'react';
import { Card, CardBody, CardHeader, Table, TableHeader, TableColumn, TableBody, TableRow, TableCell } from '@heroui/react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

interface TopContentItem {
  id: string;
  name: string;
  count: number;
}

interface TopContentTableProps {
  title: string;
  data: TopContentItem[];
  countLabel: string;
  emptyMessage: string;
  delay?: number;
}

const TopContentTable: React.FC<TopContentTableProps> = ({ title, data, countLabel, emptyMessage, delay = 0 }) => {
  const { t } = useTranslation('admin');

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay }}>
      <Card className="h-full">
        <CardHeader className="pb-2">
          <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        </CardHeader>
        <CardBody className="pt-2">
          {data.length > 0 ? (
            <Table aria-label={title} removeWrapper classNames={{ th: 'bg-default-100' }}>
              <TableHeader>
                <TableColumn>{t('dashboard.table.name')}</TableColumn>
                <TableColumn className="text-right">{countLabel}</TableColumn>
              </TableHeader>
              <TableBody>
                {data.map((item, index) => (
                  <TableRow key={item.id}>
                    <TableCell>
                      <div className="flex items-center gap-2">
                        <span className="text-xs font-medium text-default-400 w-5">{index + 1}.</span>
                        <span className="text-sm text-foreground truncate max-w-[200px]">{item.name}</span>
                      </div>
                    </TableCell>
                    <TableCell className="text-right">
                      <span className="text-sm font-medium text-foreground">{item.count}</span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <div className="flex items-center justify-center h-32 text-default-500">{emptyMessage}</div>
          )}
        </CardBody>
      </Card>
    </motion.div>
  );
};

export default TopContentTable;

